import { styled } from "@linaria/react";
import { VariantCategoriesType } from "@/components/Catalog/Categories/types";
import { cssIsActive, getCustomizeScroll } from "@/styles/utils/Utils";
import { breakpoints, colors } from "@/styles/utils/vars";
import { ButtonBase, cssButtonBackward } from "@/ui/Button/StyledButton";
import { StyledEntityImage } from "@/ui/EntityImage/Styled";
import { getTypographyBase } from "@/ui/Typography/Typography";
import { cssAngle, cssIsSelectedCategory, StyledCategory, StyledCategoryContainer, StyledCategoryFooter, StyledCategoryImage, StyledCategoryLink, StyledCategoryName, StyledCategoryTitle } from "./Category/StyledCategory";
import { StyledList } from "../../List/StyledList";
export const CategoriesInner = /*#__PURE__*/styled('div')({
  name: "CategoriesInner",
  class: "CategoriesInner_cunsawf"
});
export const StyledCategories = /*#__PURE__*/styled('section')({
  name: "StyledCategories",
  class: "StyledCategories_s1h01l6n"
});
export const StyledCategoriesPopup = /*#__PURE__*/styled(StyledCategories)({
  name: "StyledCategoriesPopup",
  class: "StyledCategoriesPopup_s1vgp8f4"
});
export const StyledCategoriesCatalog = /*#__PURE__*/styled(StyledCategories)({
  name: "StyledCategoriesCatalog",
  class: "StyledCategoriesCatalog_s1o25aad"
});
export const createCategoriesComponent = (variant: VariantCategoriesType): typeof StyledCategories => {
  switch (variant) {
    case "popup":
      return StyledCategoriesPopup;
    case "catalog":
      return StyledCategoriesCatalog;
    default:
      return StyledCategories;
  }
};

require("./StyledCategories.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledCategories.tsx");